import { styled } from 'dripsy';
import React from 'react';
import { ModalComponentProp, useModal } from 'react-native-modalfy';

import { IS_WEB } from '@utils';
import { ModalStackParamsType } from '../../modals/types';
import { ModalView } from './components/ModalView';
import { BaseText } from '../common/BaseText';
import { Button, ButtonStyleEnum } from '../common/Button';
import { ButtonsLayout as AppButtonsLayout } from '../layouts/ButtonsLayout';

const ModalViewContainer = styled(ModalView)({
  py: '$8',
  px: '$8',
  width: IS_WEB ? 343 : 289,
});

const ButtonsLayout = styled(AppButtonsLayout)({
  width: ['100%', 142],
});

const Title = styled(BaseText)({
  variant: 'text.xlarge',
  pb: '$5',
});

const Subtitle = styled(BaseText)({
  variant: 'text.medium',
  color: '$text400',
  pb: '$6',
});

export type ConfirmationModalButtonType = {
  text: string;
  style?: ButtonStyleEnum;
};

export interface IConfirmationModalParams {
  title: string;
  subtitle: string;
  buttons: ConfirmationModalButtonType[];
  onConfirm: () => void;
}

type ModalPropsType = ModalComponentProp<
  ModalStackParamsType,
  void,
  'ConfirmationModal'
>;

// TODO: For isLoading we need to find a way to keep params updated
export function ConfirmationModal({ modal }: ModalPropsType) {
  const { closeModal } = useModal<ModalStackParamsType>();

  if (!modal.params) {
    return null;
  }

  const {
    title,
    subtitle,
    buttons: [confirmBtn, cancelBtn],
    onConfirm,
  } = modal.params;

  function cancelAction() {
    closeModal();
  }

  function confirmAction() {
    onConfirm();
  }

  const confirmBtnStyle =
    confirmBtn.style ?? ButtonStyleEnum.DangerFilled;

  const cancelBtnStyle = cancelBtn.style ?? ButtonStyleEnum.Outline;

  return (
    <ModalViewContainer>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>

      <ButtonsLayout>
        <Button onPress={confirmAction} buttonStyle={confirmBtnStyle}>
          {confirmBtn.text}
        </Button>

        <Button onPress={cancelAction} buttonStyle={cancelBtnStyle}>
          {cancelBtn.text}
        </Button>
      </ButtonsLayout>
    </ModalViewContainer>
  );
}
